import $http from 'axios';
const store = {
	state: {
	  wishlist: [],
	},

	// Getters
	_setStateInStorage() {
		localStorage.setItem('wishlist', JSON.stringify(this.state.wishlist));
	},
	_getStateInStorage() {
		if (localStorage.getItem('wishlist')) {
			this.state.wishlist = JSON.parse(localStorage.getItem('wishlist'));
		}
	},

	// Mutations
	toggleWishlistItemByIdMutation(id) {
		if (this.state.wishlist.find( w => w == id)) {
			this.state.wishlist.splice(this.state.wishlist.findIndex( w => w == id), 1);
		} else {
			this.state.wishlist.push(id);
		}
		this._setStateInStorage();
	},
	setWishlistMutation(wishlist)  {
		this.state.wishlist = wishlist;
		this._setStateInStorage();
	},
	setWishlistItemsDataMutation(data) {
		this.state.wishlistItemsData = data
	},

	// Actions
	refreshWishlistFromServerAction () {
		$http.get("/actions/simple/wishlist").then(response => {
			this.setWishlistMutation(response.data);
		})
	},
	toggleWishlistItemByIdAction (id) {
		this.toggleWishlistItemByIdMutation(id);

		// Prepare Data for post
		let data = {
			action: "wishlist/items/toggle",
			elementId: id,
			[window.csrfTokenName]: window.csrfTokenValue,
		}
		let formData = new FormData();
		for(let key in data) {
			formData.append(key, data[key]);
		}
		// Post to Verbb Wishlist
		$http
			.post('', formData)
			.finally(
				() => {
					this.refreshWishlistFromServerAction()
				}
			)
	},
  }

  // Init
  store._getStateInStorage();
  store.refreshWishlistFromServerAction();

  export default store;
